import { Component, inject, OnInit } from '@angular/core';
import { UserLoginService } from '../../service/user-login.service';

@Component({
  selector: 'app-awscognito-angular2-app',
  template: '',
  standalone: false,
})
export class LogoutComponent implements OnInit {
  private userService = inject(UserLoginService);

  ngOnInit(): void {
    this.userService.logout();
  }
}
